import { Component } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-integration',
  standalone: false,
  templateUrl: './integration.component.html',
  styleUrl: './integration.component.scss',
})
export class IntegrationComponent {
  skeleton: boolean = true;
  link: { rajaongkir: string, woocommerce: string } = {
    rajaongkir: environment.url_docs_reference + '/introduction/rajaongkir-plugin',
    woocommerce: environment.plugin_url,
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.skeleton = false;
    }, 1000);
  }
}
